module.exports = __webpack_public_path__ + "img/border_brackets.2caa7039.svg";